export default __webpack_public_path__ + "static/media/BCA38.0eab7201.jpg";